module.exports = __webpack_public_path__ + "videos/technical-support.7162620.mp4";